import React, { FunctionComponent, useState } from 'react';
import { Box, Typography } from '@mui/material';

import { HelpButton, withoutZeroEntries } from '@paragon/client-tools';
import { NumericField } from '@paragon/material';
import { closeCurrentPopup, Dialog } from '@paragon/popup-state';

import { downloadMaterialDetails } from '../../store/actions/download';
import { ProjectActionScope } from '../../store/projectActionScope';
import { useAppDispatch } from '../hooks';
import { ChooseQuantities, useQuantitiesAndOptionState } from './ChooseQuantities';

export const MaterialDetailsOptionsDialog: FunctionComponent<{ readonly scope: ProjectActionScope }> = ({ scope }) => {
  const dispatch = useAppDispatch();

  const [overLengthPrice, setOverLengthPrice] = useState(9_999);
  const [quantities, setQuantities, quantityOption, setQuantityOption] = useQuantitiesAndOptionState(scope);

  return (
    <Dialog
      title="Material Details Options"
      onCancel="close"
      submitText="Detailed CSV"
      onSubmit={() => {
        dispatch(downloadMaterialDetails(scope, withoutZeroEntries(quantities), overLengthPrice, false));
        dispatch(closeCurrentPopup());
      }}
      otherButtons={{
        'Simple PDF': {
          handler: () => {
            dispatch(downloadMaterialDetails(scope, withoutZeroEntries(quantities), overLengthPrice, true));
            dispatch(closeCurrentPopup());
          },
          containedVariant: true,
        },
      }}
    >
      <Box sx={{ mb: 1, display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        <NumericField
          label="Overlength/Unknown Price"
          startAdornment="$"
          value={overLengthPrice}
          onSubmit={setOverLengthPrice}
        />
        <HelpButton>
          <Typography variant="body2">
            This is the price that will be used if a member is over your maximum stock length or if a price can&apos;t
            be found for a stock length.
          </Typography>
        </HelpButton>
      </Box>

      <Typography variant="subtitle1">Quantities</Typography>
      <ChooseQuantities
        scope={scope}
        quantityOption={quantityOption}
        quantities={quantities}
        onQuantityChange={(quantityOption, quantities) => {
          setQuantityOption(quantityOption);
          setQuantities(quantities);
        }}
      />
    </Dialog>
  );
};
